import React, { useContext, useState, useEffect, useRef } from 'react'
import Layout from '@/product/components/templates/Layout'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import '../Dashboard/Dashboard.css'
import CustomTable from '@/product/components/molecules/CustomTable'
import InvoiceContext from '@/product/context/invoice/invoiceContext'
import CartContext from '@/product/context/cart/cartContext'
import AuthContext from '@/product/context/auth/authContext'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import ReportContext from '@/product/context/report/reportContext'
import CustomDialog from '@/product/components/organisms/Dialog'
import { Button, FormControlLabel, Switch } from '@mui/material'
import { useFormik } from 'formik'
import { mapData } from '@/product/common/components'
import InvoiceView from './view'
import Loaders from '@/product/components/molecules/Loaders'
import * as Yup from 'yup'
import CustomCommonContext from '@/custom/context/common/commonContext'
import AlertContext from '@/product/context/alert/alertContext'
import bwipjs from 'bwip-js'

const Order = (props) => {
    const reportContext = useContext(ReportContext)
    const authContext = useContext(AuthContext)
    const invoiceContext = useContext(InvoiceContext)
    const cartContext = useContext(CartContext)
    const { setAlert } = useContext(AlertContext)
    const [isLoading, setIsLoading] = useState(true)
    const [isPopupLoading, setIsPopupLoading] = useState(true)
    const { getAllExportDownload } = reportContext
    const { user } = authContext
    const [searchVisible, setSearchVisible] = useState(false)
    const [showButton, setShowButton] = useState(false)
    const [reload, setReload] = useState(false)
    const [btnDisabled, setBtnDisabled] = useState(false)

    const [selectedValues, setSelectedValues] = useState([])
    const { getGlobalVariable, alldata_all_dropdown } =
        useContext(CustomCommonContext)
    const [retrievalOption, setRetrievalOption] = useState([])

    const {
        all_invoices,
        getAllInvoices,
        single_invoice,
        getSingleInvoice,
        getInvoiceDetails,
        invoice_details,
        changeProductStatus,
        responseStatus: responseStatusInvoice,
    } = invoiceContext
    const { responseStatus: responseStatusCart } = cartContext
    const [productLength, setProductLength] = useState(0)

    const [changeStatus, setChangeStatus] = useState(false)
    const [transitStatus, setTransitStatus] = useState(false)
    const [singleDetails, setSingleDetails] = useState([])
    const [showInTransitTable, setShowInTransitTable] = useState(false)

    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
        sid: 0,
    })

    const [manageCredits, setManageCredits] = useState({
        popup: false,
        status: 'new',
        id: 0,
        sid: 0,
    })

    const [clearNewInvoicesBtn, setClearNewInvoicesBtn] = useState(false)

    const [printId, setPrintId] = useState({
        id: '0',
        auctionId: '0',
        type: '',
    })

    const printRef = useRef()

    const toggleFullScreenPopup = (popup, status, id, sid) => {
        if (popup) {
            setManage({ popup, status, id, sid })
        } else {
            console.log('closing')
            setManage({ popup, status: 'new', id: 0, sid: 0 })
            setSearchData([])
        }
    }

    const toggleCreditsPopup = (popup, status, id, sid) => {
        if (popup) {
            setManageCredits({ popup, status, id, sid })
        } else {
            setManageCredits({ popup, status: 'new', id: 0, sid: 0 })
        }
    }

    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const changeTransitStatus = () => {
        setTransitStatus(!transitStatus)
    }

    let action = props.match.params.action

    const [tableBody, setTableBody] = useState([])
    const [inTransitInvoices, setInTransitInvoices] = useState([])
    const [pickupInvoices, setPickupInvoices] = useState([])
    const [searchData, setSearchData] = useState([])
    const [showNewInvoice, setShowNewInvoice] = useState(false)
    const [customLoaded, setCustomLoaded] = useState(false)

    const [clearAutocomplete, setClearAutocomplete] = useState(false)

    let tableBodyRef = useRef(tableBody)
    useEffect(() => {
        tableBodyRef.current = tableBody
    })

    const openPopup = (popup) => {
        if (popup === 'changeStatus') {
            setChangeStatus(true)
        }
        if (popup === 'transitStatus') {
            setTransitStatus(true)
        }
    }

    const handlePopup = (popup) => {
        if (customLoaded) {
            openPopup(popup)
            setIsPopupLoading(false)
        } else {
            // setIsPopupLoading(true)
            // setTimeout(() => {
            //     setIsPopupLoading(false)
            // }, 2000)
            openPopup(popup)
            setIsPopupLoading(false)
        }
    }

    const actions = [
        'new',
        'intransit',
        'pickup',
        'completed',
        'cancelled',
        'undelivered',
    ]

    const formikInvoice = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            filters: {
                action: {
                    value: action === 'new' ? 'paid' : null,
                    type: 'in',
                    field: 'b.paid',
                },
                active: {
                    value: 2,
                    type: 'all',
                    field: 'b.active',
                },
                searchterm: {
                    value: '',
                    type: 'like',
                    field: 'b.common_invoice',
                },
                fromdate: {
                    value: '',
                    type: 'dategreaterequal',
                    field: 'b.date_added',
                    withTime: true,
                },
                todate: {
                    value: '',
                    type: 'datesmallerequal',
                    field: 'b.date_added',
                    withTime: true,
                },
                payreject: {
                    value: 0,
                    type: 'in',
                    field: 'b.pay_reject',
                },
                retrieval_location: {
                    value: '',
                    type: 'in',
                    field: 'it.location',
                },
            },
        },
        onSubmit: (values) => {
            setIsLoading(true)
            values.timeZone = Intl.DateTimeFormat().resolvedOptions()
            getAllInvoices(values)
        },
    })

    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            invoice_id: '',
            action: 'orderControl',
            filters: {
                active: {
                    value: 2,
                    type: 'all',
                    field: 'b.active',
                },
                delivered: {
                    value: 0,
                    type: 'in',
                    field: 'b.delivered',
                },
                paid: {
                    value: 1,
                    type: 'in',
                    field: 'b.paid',
                },
            },
        },
        validationSchema: Yup.object({
            invoice_id: Yup.string(),
        }),
        onSubmit: (values) => {
            if (values.invoice_id !== '') {
                changeSingleDetails(values.invoice_id)
                setIsLoading(true)
                getInvoiceDetails(values, 'order')
            }
        },
    })
    const formikSearch = useFormik({
        initialValues: {
            item_id: '',
        },
        validationSchema: Yup.object({
            item_id: Yup.string().required('Required!'),
        }),
        onSubmit: (values) => {
            console.log('i am here 1', values)
            handleConfirm(values)
        },
    })

    const getBuynowID = (project_id) => {
        console.log('i am getBuynowID 1', tableBody)
        console.log('i am getBuynowID 2', tableBodyRef.current)
        let tableBody_ = tableBodyRef.current
        console.log('i am getBuynowID 3', tableBody_)
        // let buynowID = tableBody_.filter(
        //     (item) => item.project_id === project_id
        // )[0]?.id
        let buynowID = tableBody_.filter(
            (item) =>
                parseInt(item?.projects_id, 10) === parseInt(project_id, 10)
        )[0]?.id
        console.log(
            'i am getBuynowID 4',
            project_id,
            tableBody_,
            tableBody_.filter((item) => item?.projects_id === project_id),
            tableBody_.filter((item) => item?.projects_id === project_id)[0],
            tableBodyRef.current,
            buynowID
        )
        return buynowID
    }

    const handleConfirm = (data) => {
        let newSelected = []
        console.log(data, 'ddd')
        if (data.item_id !== '') {
            // let newValue = parseInt(data.item_id)
            let buynowId = getBuynowID(data.item_id)
            console.log(searchData, 'sergggg')
            if (buynowId) {
                newSelected = newSelected.concat(searchData, buynowId)
            } else {
                newSelected = [...searchData]
            }
        }
        console.log(newSelected, 'newww')
        setSearchData(newSelected)
    }

    const handleConfirmMultiple = (data) => {
        let newSelected = []
        console.log(data, 'dddddd')
        if (data.length) {
            data.map((item) => {
                if (item.item_id !== '') {
                    // let newValue = parseInt(item.item_id)
                    let buynowId = getBuynowID(data.item_id)
                    if (buynowId) {
                        newSelected.push(buynowId)
                    }
                    console.log('i am final buy now', buynowId)
                    // newSelected = newSelected.concat(searchData, newValue)
                }
            })
        }
        console.log(newSelected, 'newwwwwwwww')
        setSearchData((prevState) => [...prevState, ...newSelected])
        // setSearchData([...searchData,newSelected])
    }

    const formikSelection = useFormik({
        initialValues: {
            action: '',
            project_id: '',
            auction_id: '',
            notes: '',
            status: 0,
        },
        onSubmit: (values) => {
            console.log('formikSelection ', values)
            if (
                action === 'new' &&
                values.project_id.length &&
                values.status !== 4
            ) {
                onClickPrint(values.project_id[0], 0, 'lot_label')
            }
            if (values.action === 'order_control') {
                values.changeMarketStatus = true
                values.market_status = 'closed'
                changeProductStatus(values)
                setBtnDisabled(true)
            }
        },
    })

    const formikIntransit = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            action: 'orderControl',
            multiple: true,
            filters: {
                active: {
                    value: 2,
                    type: 'all',
                    field: 'b.active',
                },
                delivered: {
                    value: 0,
                    type: 'in',
                    field: 'b.delivered',
                },
                invoice_ids: {
                    value: [],
                    type: 'array',
                    field: 'b.common_invoice',
                },
                paid: {
                    value: 1,
                    type: 'in',
                    field: 'b.paid',
                },
            },
        },
        onSubmit: (values) => {
            console.log('something here ', values)
            if (values?.filters?.invoice_ids?.value?.length) {
                setIsLoading(true)
                getInvoiceDetails(values, 'order')
            }
        },
    })

    useEffect(() => {
        formikSearch.setFieldValue('item_id', '')
        formikSearch.setTouched({})
    }, [searchData])

    useEffect(() => {
        if (action === 'intransit') {
            console.log('I AM FORMIK ', formikIntransit.values)
            if (formikIntransit?.values?.filters?.invoice_ids?.value?.length) {
                formikIntransit.handleSubmit()
            } else {
                setTableBody([])
                // formikIntransit.setFieldValue('filters.invoice_ids.value', [])
            }
        }
    }, [formikIntransit?.values?.filters])

    useEffect(() => {
        if (invoice_details) {
            console.log(invoice_details, 'singggs')
            if (invoice_details.invoicerecords.length) {
                let invoiceData = []
                if (action === 'intransit') {
                    let inTransitData = []
                    invoiceData = invoice_details.invoicerecords.filter(
                        (value) => value.delivered === 1
                    )
                    let _inTransitData = invoiceData
                    _inTransitData.map((item) => {
                        inTransitData.push({
                            item_id: item.project_id,
                            page: 1,
                        })
                    })
                    console.log('i am here 1', inTransitData)
                    handleConfirmMultiple(inTransitData)
                } else if (action === 'pickup') {
                    formik.values.invoice_id = ''
                    invoiceData = invoice_details.invoicerecords.filter(
                        (value) => value.delivered === 2
                    )
                } else if (action === 'completed') {
                    invoiceData = invoice_details.invoicerecords.filter(
                        (value) => value.delivered === 3
                    )
                } else {
                    if (action === 'new') {
                        formik.values.invoice_id = ''
                    }
                    invoiceData = invoice_details.invoicerecords.filter(
                        (value) => value.delivered === 0
                    )
                }
                // let invoiceData = invoice_details.invoicerecords
                let length = invoiceData.length
                console.log(length, 'lennn')
                setProductLength(length)
                setTableBody(invoiceData)
                setShowNewInvoice(true)
            } else {
                setProductLength(0)
                setTableBody([])
                setShowNewInvoice(false)
            }

            if (
                invoice_details.invoicerecords.length &&
                invoice_details.from === 'order'
            ) {
                setSearchVisible(true)
            } else {
                setSearchVisible(false)
            }
        }
        setIsLoading(false)
    }, [invoice_details, action])

    useEffect(() => {
        if (all_invoices) {
            if (action !== 'intransit') {
                setTableBody(
                    all_invoices.records.length ? all_invoices.records : []
                )
                setIsLoading(false)
                setClearNewInvoicesBtn(!clearNewInvoicesBtn)
            }
            if (action === 'intransit') {
                let inTransit = []
                all_invoices.records.length
                    ? all_invoices.records.map((item) => {
                          inTransit.push({
                              show: item.common_invoice.toString(),
                              value: item.common_invoice,
                          })
                      })
                    : []
                // console.log('setInTransitInvoices ', all_invoices, inTransit)
                setInTransitInvoices(inTransit.length ? inTransit : [])
                if (showInTransitTable)
                    setTableBody(
                        all_invoices.records.length ? all_invoices.records : []
                    )
            }
            // if (action === 'pickup') {
            //     let inTransit = []
            //     all_invoices.records.length
            //         ? all_invoices.records.map((item) => {
            //               inTransit.push({
            //                   show: item.common_invoice.toString(),
            //                   value: item.common_invoice,
            //               })
            //           })
            //         : []
            //     console.log('setInTransitInvoices ', all_invoices, inTransit)
            //     setPickupInvoices(inTransit.length ? inTransit : [])
            // }
            setShowNewInvoice(false)
            setIsLoading(false)
        }
    }, [all_invoices])

    useEffect(() => {
        setTableBody([])
        setSearchData([])
        setSearchVisible(false)
        setSingleDetails([])
        formik.values.invoice_id = ''
        formikInvoice.values.filters.fromdate.value = ''
        formikInvoice.values.filters.todate.value = ''
        formikInvoice.values.filters.searchterm.value = ''
        formikSearch.values.item_id = ''
        setReload(!reload)
        console.log('pickupstate123', clearAutocomplete)
        console.log('hello miss')
        if (action === 'intransit') {
            formikIntransit.setFieldValue('filters.invoice_ids.value', [])
            setClearAutocomplete(!clearAutocomplete)
            formikInvoice.values.filters.action.value = action
            formikInvoice.values.limit = 20000
            formikInvoice.values.page = 1
            getAllInvoices(formikInvoice.values)
        } else if (action === 'pickup') {
            // console.log('pickupstate', clearAutocomplete)
            // setClearAutocomplete(!clearAutocomplete)
            // formikIntransit.setFieldValue('filters.invoice_ids.value', [])
            formikInvoice.values.filters.action.value = action
            formikInvoice.values.limit = 20
            setIsLoading(true)
            getAllInvoices(formikInvoice.values)
        } else if (action !== 'pickup' && action !== 'intransit') {
            formikInvoice.values.limit = 20
            if (action === 'new') {
                formikInvoice.values.filters.action.value = 'new'
                formikInvoice.values.filters.payreject.value = '0'
            } else if (action === 'undelivered') {
                formikInvoice.values.filters.action.value = 'unpaid'
                formikInvoice.values.filters.payreject.value = 1
            } else {
                formikInvoice.values.filters.payreject.value = '0'
                formikInvoice.values.filters.action.value = action
            }
            setIsLoading(true)
            getAllInvoices(formikInvoice.values)
        } else {
            setTableBody([])
        }
        if ((action !== 'new') | (action !== 'pickup')) {
            setShowNewInvoice(false)
        }
        console.log(
            formikIntransit.values.filters.invoice_ids.value,
            'invoice_ids'
        )
        // setIsLoading(true)
        // formik.values.filters.action.value = action
        // formik.values.page = 1
        // formik.values.filters.fromdate.value = ''
        // formik.values.filters.todate.value = ''
        // formik.values.filters.searchterm.value = ''
        // if (action === 'all') {
        //     formik.values.filters.active.type = 'all'
        // } else {
        //     formik.values.filters.active.type = action === 'cancel' ? 'in' : 'notin'
        //     formik.values.filters.active.value = 2
        // }

        // getAllInvoices(formik.values)
        // return () => {
        //     setTableBody([])
        // }
    }, [props.match.params.action])

    const onClickView = (id, sid, type) => {
        console.log('sid', sid)
        console.log('typpeee', type)
        toggleFullScreenPopup(true, type, id, sid)
    }

    const onClickEdit = (id, secondaryID, type) => {
        toggleCreditsPopup(true, type, id, secondaryID)
    }

    const changeSingleDetails = (id) => {
        console.log(id, tableBodyRef.current, 'seconff 1111')
        let tableValue = tableBodyRef.current.filter(
            (cat) => parseInt(cat.common_invoice, 10) === parseInt(id, 10)
        )
        console.log(tableValue, 'seconff 2222')
        setSingleDetails(tableValue)
    }

    const onClickAdd = (id, secondaryID, type) => {
        let tableValue = tableBodyRef.current.filter(
            (cat) => parseInt(cat.id, 10) === parseInt(secondaryID, 10)
        )
        formik.values.invoice_id = id
        console.log(secondaryID, 'seconff')
        setSingleDetails(tableValue)
        getInvoiceDetails(formik.values, 'order')
    }

    const onClickPrint = (id, secondaryID, type) => {
        console.log(singleDetails, 'ghhh')
        let selectedProduct = tableBodyRef.current.filter(
            (cat) => parseInt(cat.id, 10) === parseInt(id, 10)
        )
        console.log('i am here print ', id, secondaryID, type, selectedProduct)

        // let canvas = bwipjs.toCanvas('barcode-canvas', {
        //     bcid: 'code128',
        //     text: selectedProduct[0]?.common_invoice.toString(),
        //     width: 120,
        //     height: 50,
        //     includetext: false,
        //     textxalign: 'center',
        // })
        setPrintId({
            id: selectedProduct[0]?.common_invoice,
            auctonId: secondaryID,
            type: type,
        })

        setTimeout(() => {
            console.log(
                'i am going print ',
                id,
                type,
                singleDetails,
                selectedProduct
            )
            if (type == 'lot_label' && singleDetails.length) {
                PrintPreview(id, type, singleDetails[0])
            } else {
                PrintPreview(id, type, selectedProduct[0])
            }
        }, 1000)
        setClearNewInvoicesBtn(!clearNewInvoicesBtn)
    }

    useEffect(() => {
        try {
            if (printId.id != '0') {
                console.log(printId, 'printt')

                let canvas = bwipjs.toCanvas('barcode-canvas', {
                    bcid: 'code128',
                    text: printId.id.toString(),
                    // scale: 8,
                    width: 120,
                    height: 50,
                    includetext: false,
                    textxalign: 'center',
                })
            }
        } catch (e) {
            console.log('error!')
        }
    }, [printId])

    const PrintPreview = (product_id, type, product) => {
        let userLocation = product?.user_bid_custom_data_location_id
            ? alldata_all_dropdown[
                  alldata_all_dropdown.findIndex(
                      (ele) =>
                          ele.id == product?.user_bid_custom_data_location_id
                  )
              ]?.description
            : ''

        console.log(product, 'printing')
        let printWindow
        printWindow = window.open(
            '',
            '',
            'location=1,status=1,scrollbars=1,width=450px,height=135px'
        )
        printWindow.document.write('<html style="margin: 1mm;"><head>')
        printWindow.document.write(
            '<style media="print" type="text/css"> @page { size: auto; margin: 0mm;}</style>'
        )
        printWindow.document.write('</head><body style="margin: 0mm;">')
        printWindow.document.write(
            '<div style="width:100%;text-align:center;">'
        )
        let qrCodeElement = document.getElementById('barcode-canvas')
        let qrCodeImageSrc = qrCodeElement.toDataURL() // Get the QR code as an image source
        console.log('i am canvas ', qrCodeElement, qrCodeImageSrc)

        printWindow.document.write(
            `<img src="${qrCodeImageSrc}" alt="QR Code" width="200" height="30" />`
        )

        printWindow.document.write(
            '<div style="width:200px;height:70px;margin:auto;">'
        )

        printWindow.document.write('<div style="float: left;width: 70%;">')

        // printWindow.document.write(
        //     `<p style="font-weight: bolder; font-size: 18px; width:100%; height:auto; margin:0; padding-top:5px;text-align:left;">AUCTION EVENT# ${auction_id}
        //         </p>`
        // )
        // printWindow.document.write(
        //     `<p style="font-weight: bolder; font-size: 18px; width:100%; height:auto; margin:0; padding-top:0px;text-align:left;">LOT# ${product_id}
        //         </p>`
        // )

        printWindow.document.write(
            `<p style="font-weight: bolder; font-size: 25px; width:100%; height:auto; margin:0; padding-top:10px;text-align:left;">${
                userLocation || ''
            }
                </p>`
        )
        printWindow.document.write('</div>')
        printWindow.document.write('<div style="float: left;width: 30%;">')
        printWindow.document.write(
            `<p style="font-weight: bolder; font-size: 25px; width:100%; height:auto; margin:0;padding-bottom: 10px;padding-top: 10px;text-align:left;">${
                product?.common_invoice || ''
            }
                </p>`
        )
        printWindow.document.write('</div>')
        printWindow.document.write('<div style="float: left;width: 100%;">')
        printWindow.document.write(
            `<p style="font-weight: bolder; font-size: 28px; width:100%; height:auto; margin:0; text-align:left;">
            ${`${String(product?.users_first_name)?.charAt(0)}  ${
                product?.users_last_name || ''
            }`}
                </p>`
        )
        printWindow.document.write('</div>')
        printWindow.document.write('</div>')
        printWindow.document.write('</div>')
        //here 'forPrintPreview' is the id of the 'div' in current page(aspx).
        printWindow.document.write('</body></html>')
        printWindow.document.close()
        setTimeout(() => {
            printWindow.print()
        }, 1000)
    }

    const onSelectMultiProducts = (data, status) => {
        console.log('i am order status MultiProducts order', status, data)
        console.log(data, status, 'dddd')
        formikSelection.values.action = 'order_control'
        formikSelection.values.status = status
        formikSelection.values.project_id = data
        let selectedValues = data

        if (status === 0 || status === 4) {
            handlePopup('changeStatus')
        } else if (status === 1 || status === 2) {
            if (data.length === productLength) {
                handlePopup('changeStatus')

                // console.log('is this place')
            } else {
                if (status == 1) {
                    if (
                        user.emp_type == 'super_admin' ||
                        user.emp_type == 'admin'
                    ) {
                        handlePopup('changeStatus')
                    } else {
                        setAlert(
                            'Please contact Admin / Super Admin to move this to transit',
                            'error'
                        )
                    }
                } else {
                    handlePopup('changeStatus')
                }
            }
        } else if (status === 5) {
            toggleFullScreenPopup(true, 'print', data, 0)
        } else if (status === 'multi_view') {
            toggleFullScreenPopup(true, 'multi_view', data, 0)
        } else if (status === 3) {
            handleOrderSubmit(3)
            // handlePopup('transitStatus')
        }
    }
    const getProductMultipleAction = () => {
        let actionPush = [
            {
                buttonType: 'text_snippet',
                clickType: 'lot_label',
                clickID: 'id',
                onclick: onClickPrint,
                secondaryClickID: 'projects_auctionid',
                tooltipTitle: 'Print Label',
            },
        ]
        return actionPush
    }

    const getMultipleAction = () => {
        let actionPush = [
            {
                buttonType: 'visibility',
                clickType: 'view',
                onclick: onClickView,
                secondaryClickID: 'user_id',
                tooltipTitle: 'View invoice',
            },
            {
                buttonType: 'text_snippet',
                clickType: 'label',
                clickID: 'id',
                onclick: onClickPrint,
                secondaryClickID: 'auctionid',
                tooltipTitle: 'Print Label',
            },
        ]
        if (action === 'unpaid' || action === 'draft') {
            actionPush.push({
                buttonType: 'monetization_on',
                clickType: 'edit',
                onclick: onClickEdit,
                secondaryClickID: 'user_id',
                tooltipTitle: 'Make payment',
            })
        }
        if (action === 'new' || action === 'pickup') {
            actionPush.push({
                buttonType: 'launch',
                clickType: 'edit',
                onclick: onClickAdd,
                tooltipTitle: 'View Product',
                clickID: 'common_invoice',
                secondaryClickID: 'id',
            })
        }
        return actionPush
    }

    const tableValues = []

    const tableValuesForLots = [
        {
            field: 'id',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'ID',
        },
        {
            field: 'projects_id',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Lot Id',
        },
        {
            field: 'projects_avatar',
            type: 'imagewithurl',
            folder: 'product',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'Picture',
        },
        {
            field: 'projects_title',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Title',
        },
        {
            field: 'custom_projects_inventory_location',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Inventory Location',
        },
        {
            field: 'common_invoice',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Invoice ID',
        },
        {
            field: 'users_first_name,users_last_name',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'User/Company',
        },
        {
            field: 'users_email',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Email',
        },
        {
            field: 'qty',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Qty',
        },
        {
            field: 'amount',
            type: 'price',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Price',
        },
        {
            field: 'action',
            type: 'button',
            clickID: 'common_invoice',
            sort: false,
            firstChild: false,
            disablePadding: false,
            secondaryClickID: 'user_id',
            label: 'Action',
            isMultiple: getProductMultipleAction(),
        },
    ]

    const tableValuesForInvoice = [
        {
            field: 'common_invoice',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Invoice ID',
        },
        {
            field: 'total_items',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Items',
        },
        {
            field: 'total_invoice',
            type: 'price',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Amount',
        },
        {
            field: 'users_first_name,users_last_name',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'User/Company',
        },
        {
            field: 'users_email',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Email',
        },
        // {
        //     field: 'user_bid_custom_data_location_id',
        //     type: 'dropdown',
        //     firstChild: true,
        //     sort: showNewInvoice === false && action === 'new' ? true : false,
        //     disablePadding: false,
        //     label: 'Retrieval Location',
        //     dropdownFilterBy: 'id',
        //     dropdownReturnVariable: 'description',
        // },
        {
            field: 'date_added',
            type: 'date',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Created Date',
        },
        {
            field: 'action',
            type: 'button',
            clickID: 'common_invoice',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            isMultiple: getMultipleAction(),
        },
    ]

    if (
        (action === 'new' && showNewInvoice) ||
        (action === 'pickup' && showNewInvoice)
    ) {
        tableValues.push(...tableValuesForLots)
    }

    if (showNewInvoice === false && action !== 'intransit') {
        tableValues.push(...tableValuesForInvoice)
    }

    if (action === 'intransit') {
        if (showInTransitTable) {
            tableValues.push(...tableValuesForInvoice)
        } else {
            tableValues.push(...tableValuesForLots)
        }
    }

    const tableActions = []
    if (
        (action === 'intransit' || action === 'pickup') &&
        !showInTransitTable
    ) {
        // tableActions.push({
        //     label: 'Move to Pending',
        //     icon: <span className="material-icons">cancel</span>,
        //     onclick: onSelectMultiProducts,
        //     type: 0,
        // })

        tableActions.push({
            label: 'Move to Cancelled',
            icon: <span className="material-icons">do_disturb</span>,
            onclick: onSelectMultiProducts,
            type: 4,
        })
    }

    if (action === 'new' && showNewInvoice) {
        tableActions.push(
            {
                label: 'Ready for Pickup',
                icon: <span className="material-icons">add_task</span>,
                onclick: onSelectMultiProducts,
                type: 2,
            },
            {
                label: 'Move to In Transit',
                icon: <span className="material-icons">check_circle</span>,
                onclick: onSelectMultiProducts,
                type: 1,
            }
        )

        tableActions.push({
            label: 'Move to Cancelled',
            icon: <span className="material-icons">do_disturb</span>,
            onclick: onSelectMultiProducts,
            type: 4,
        })
    }

    if (action === 'intransit' && !showInTransitTable) {
        tableActions.push({
            label: 'Ready for Pickup',
            icon: <span className="material-icons">check_circle</span>,
            onclick: onSelectMultiProducts,
            type: 2,
        })
    }

    if (action === 'pickup') {
        tableActions.push({
            label: 'Move to Completed',
            icon: <span className="material-icons">check_circle</span>,
            onclick: onSelectMultiProducts,
            type: 3,
        })
    }

    tableActions.push({
        label: 'View Multiple Invoice',
        icon: <span className="material-icons">visibility</span>,
        onclick: onSelectMultiProducts,
        type: 'multi_view',
    })

    tableActions.push({
        label: 'Print Invoice',
        icon: <span className="material-icons">print</span>,
        onclick: onSelectMultiProducts,
        type: 5,
    })

    const orderSearch = {
        formik: formikSearch,
        data: [
            {
                label: 'Lot ID',
                placeholder: 'Enter Lot ID',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'item_id',
                autoFocus: action === 'new' && showNewInvoice ? true : false,
            },
        ],
    }

    const orderData = {
        formik: formik,
        data: [
            {
                label: 'Invoice Number',
                placeholder: 'Enter invoice number',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'invoice_id',
                // autoFocus: true,
                forcedAutoFocus: true,
                forcedAutoFocusUpdateDependency: clearNewInvoicesBtn,
            },
        ],
    }

    const intransitOrderData = {
        formik: formikIntransit,
        data: [
            {
                label: 'Invoice Number',
                placeholder: 'Enter invoice number',
                class: 'col autoCptField',
                type: 'autocomplete',
                name: 'invoice_ids',
                options:
                    action === 'pickup' ? pickupInvoices : inTransitInvoices,
                filter: true,
                multiple: true,
                onClear: clearAutocomplete,
                autoFocus: true,
                forcedAutoFocus: true,
                forcedAutoFocusUpdateDependency: window.location.pathname,
            },
        ],
    }

    const searchInfo = {
        formik: formikInvoice,
        data: [
            {
                label: 'Invoice Number',
                placeholder: 'Enter invoice number',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'searchterm',
                filter: true,
            },
            {
                label: 'Created From Date',
                placeholder: 'Date Ending from',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'date',
                name: 'fromdate',
                filter: true,
            },
            {
                label: 'Created To Date',
                placeholder: 'Date Ending To',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'date',
                name: 'todate',
                filter: true,
            },
        ],
    }

    const retrievalLocationSearch = {
        formik: formikInvoice,
        data: [
            {
                label: 'Lot Location',
                placeholder: 'Select Lot Location',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'select',
                name: 'retrieval_location',
                filter: true,
                options: alldata_all_dropdown
                    .filter((maincat) => maincat.variable === 'location')
                    .map((maincat) => {
                        let locationChanged = {}
                        locationChanged.show = maincat.description
                        locationChanged.value = maincat.id
                        return locationChanged
                    }),
            },
        ],
    }

    const reasonForCancelInvoice = [
        {
            label: 'Reason *',
            name: 'notes',
            type: 'text',
            placeholder: 'Reason for cancellation',
            formik: formikSelection,
        },
    ]

    const handleOrderSubmit = (status) => {
        if (selectedValues.length) {
            if (selectedValues.length === productLength) {
                formikSelection.values.action = 'order_control'
                formikSelection.values.status = status
                formikSelection.values.project_id = selectedValues
                if (status == 3) {
                    changeProductStatus(formikSelection.values)
                } else {
                    handlePopup('changeStatus')
                }
            } else {
                if (status == 1) {
                    if (
                        user.emp_type == 'super_admin' ||
                        user.emp_type == 'admin'
                    ) {
                        handlePopup('transitStatus')
                    } else {
                        setAlert(
                            'Please contact Admin / Super Admin to move this to transit',
                            'error'
                        )
                    }
                } else {
                    handlePopup('transitStatus')
                }
            }
        }
    }

    const handleDelivery = () => {
        if (selectedValues.length) {
            if (selectedValues.length === productLength) {
                formikSelection.values.action = 'delivered'
                formikSelection.values.project_id = selectedValues
                handlePopup('changeStatus')
            } else {
                handlePopup('transitStatus')
            }
        }
    }

    const transitConfirm = () => {
        formikSelection.values.action = 'order_control'
        formikSelection.values.project_id = selectedValues
        formikSelection.values.status =
            action === 'new'
                ? 1
                : action === 'intransit'
                  ? 2
                  : action === 'pickup'
                    ? 3
                    : 0
        let missing = []
        let allProducts = tableBodyRef.current
        console.log('transitConfirm here ', allProducts, selectedValues)
        if (allProducts.length) {
            allProducts.map((data) => {
                if (!selectedValues.includes(data.id)) {
                    missing.push(data.id)
                }
            })
        }
        if (action === 'new' && selectedValues.length) {
            onClickPrint(selectedValues[0], 0, 'lot_label')
        }
        changeProductStatus({
            action: 'order_control',
            project_id: missing,
            auction_id: '',
            notes: '',
            status: 5,
        })
        changeProductStatus(formikSelection.values)
        setBtnDisabled(true)
        console.log(selectedValues, 'selecting', missing)
    }

    const selectedUpdate = (data) => {
        console.log(data, 'sdddd')
        if (data.length) {
            setShowButton(true)
            formik.values.invoice_id = ''
        } else {
            setShowButton(false)
        }
        setSelectedValues(data)
    }

    useEffect(() => {
        if (responseStatusInvoice) {
            if (
                responseStatusInvoice.status === 'success' &&
                responseStatusInvoice.from === 'productchange'
            ) {
                setChangeStatus(false)
                formikSearch.values.item_id = ''
                formik.values.invoice_id = ''
                setTransitStatus(false)
                setSearchVisible(false)
                setTableBody([])
                if (formik.values.invoice_id !== '') {
                    getInvoiceDetails(formik.values, 'order')
                }
                if (action === 'intransit') {
                    formikIntransit.values.filters.invoice_ids.value = []
                    // formikIntransit.setFieldValue('filters.invoice_ids.value', [])
                    setClearAutocomplete(!clearAutocomplete)
                    setInTransitInvoices([])
                    setReload(!reload)
                    getAllInvoices(formikInvoice.values)
                } else if (action === 'new') {
                    formikInvoice.values.filters.action.value = 'new'
                    formikInvoice.values.filters.payreject.value = '0'
                    setIsLoading(true)
                    getAllInvoices(formikInvoice.values)
                } else if (action === 'pickup') {
                    formikInvoice.values.filters.action.value = action
                    setIsLoading(true)
                    getAllInvoices(formikInvoice.values)
                }
                // getAllInvoices(formik.values)
            } else if (
                responseStatusInvoice.status === 'error' &&
                responseStatusInvoice.from === 'order'
            ) {
                setIsLoading(false)
            }
            setBtnDisabled(false)
        }
    }, [responseStatusInvoice])

    useEffect(() => {
        setIsLoading(true)
        formikInvoice.values.page = 1
        formikInvoice.values.filters.fromdate.value = ''
        formikInvoice.values.filters.todate.value = ''
        formikInvoice.values.filters.searchterm.value = ''
        formikInvoice.values.filters.action.value = action

        if (showInTransitTable) {
            formikIntransit.setFieldValue('filters.invoice_ids.value', [])
            setClearAutocomplete(!clearAutocomplete)
            formikInvoice.values.limit = 20
        } else {
            formikInvoice.values.limit = action === 'intransit' ? 20000 : 20
            setTableBody([])
        }
        getAllInvoices(formikInvoice.values)
    }, [showInTransitTable])

    useEffect(() => {
        if (responseStatusCart) {
            if (responseStatusCart.status === 'success') {
                if (responseStatusCart.from === 'payCartWallet') {
                    toggleCreditsPopup(false)
                    getAllInvoices(formik.values)
                } else if (responseStatusCart.from === 'payCartOffline') {
                    toggleCreditsPopup(false)
                    getAllInvoices(formik.values)
                }
            }
        }
    }, [responseStatusCart])

    const clearNewInvoices = () => {
        console.log('i am clicked')
        setTableBody([])
        formikSearch.values.item_id = ''
        formikInvoice.values.filters.retrieval_location.value = ''
        formik.setFieldValue('invoice_id', '')
        setClearNewInvoicesBtn(!clearNewInvoicesBtn)
        setSearchData([])
        setSingleDetails([])
        setShowNewInvoice(false)
        setSearchVisible(false)
        getAllInvoices(formikInvoice.values)
    }

    const updateFunction = () => {
        getAllInvoices(formikInvoice.values)
    }
    useEffect(() => {
        setClearNewInvoicesBtn(!clearNewInvoicesBtn)
    }, [window.location.pathname])

    console.log('searchData', searchData)
    return (
        <Layout>
            <div ref={printRef} className="printBarcode">
                <canvas id="barcode-canvas"></canvas>
            </div>
            <div className="dashboard invoice">
                {action === 'new' ? (
                    <CustomSearch
                        searchInfo={retrievalLocationSearch}
                        formik={formikInvoice}
                    />
                ) : null}
                {action === 'intransit' ? (
                    <>
                        {!showInTransitTable ? (
                            <CustomSearch
                                searchInfo={intransitOrderData}
                                formik={formik}
                            />
                        ) : (
                            <CustomSearch
                                searchInfo={searchInfo}
                                formik={formikInvoice}
                            />
                        )}
                        <div className="d-flex justify-content-start">
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={showInTransitTable}
                                        onChange={() =>
                                            setShowInTransitTable(
                                                (showInTransitTable) =>
                                                    !showInTransitTable
                                            )
                                        }
                                    />
                                }
                                label="Table View"
                            />
                        </div>
                    </>
                ) : action === 'new' || action === 'pickup' ? (
                    <CustomSearch searchInfo={orderData} formik={formik} />
                ) : (
                    <CustomSearch
                        searchInfo={searchInfo}
                        formik={formikInvoice}
                    />
                )}

                {/* <div className="d-flex justify-content-end">
                            <Button
                                id="invoice_report"
                                onClick={() =>
                                    getAllExportDownload({
                                        action: 'export',
                                        order: 'asc',
                                        orderby: '',
                                        search: 'all',
                                        report: `${action}_invoice_management`,
                                    })
                                }
                            >
                                <span className="material-icons">get_app</span>Export All Data
                            </Button>
                        </div> */}
                {(searchVisible && action === 'new') ||
                (searchVisible && action === 'pickup') ? (
                    <>
                        <div className="commActBox d-flex justify-content-between align-items-center">
                            <div className="w-100">
                                <form
                                    onSubmit={formikSearch.handleSubmit}
                                    className="row customSearchInner flex-wrap d-flex justify-content-start align-items-center"
                                >
                                    {mapData(orderSearch)}
                                    <div className="col-auto ml-auto btnSearch">
                                        <PrimaryButton
                                            id="customSearch_submit"
                                            label="CONFIRM"
                                            type="submit"
                                        />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </>
                ) : null}

                {(searchVisible && action === 'new') ||
                (searchVisible && action === 'pickup') ? (
                    <div className="row">
                        <div className="ml-auto col-sm-3 col-12 btnSearch">
                            <PrimaryButton
                                id="customSearch_submit"
                                label={'Clear'}
                                onClick={() => clearNewInvoices()}
                            />
                        </div>
                    </div>
                ) : null}

                {showButton && isLoading === false ? (
                    action === 'new' && showNewInvoice ? (
                        <div className="col-auto d-flex justify-content-center m-auto btnSearch">
                            <PrimaryButton
                                id="customSearch_submit"
                                label={'Move to In Transit'}
                                onClick={() => handleOrderSubmit(1)}
                            />
                        </div>
                    ) : action === 'intransit' && !showInTransitTable ? (
                        <div className="col-auto d-flex justify-content-center m-auto btnSearch">
                            <PrimaryButton
                                id="customSearch_submit"
                                label={'Ready for Pickup'}
                                onClick={() => handleOrderSubmit(2)}
                            />
                        </div>
                    ) : action === 'pickup' ? (
                        <div className="col-auto d-flex justify-content-center m-auto btnSearch">
                            <PrimaryButton
                                id="customSearch_submit"
                                label={'Move to Completed'}
                                onClick={() => handleOrderSubmit(3)}
                            />
                        </div>
                    ) : null
                ) : null}
                {isLoading ? (
                    <Loaders isLoading={isLoading} />
                ) : (
                    <>
                        <CustomTable
                            formik={
                                (!searchVisible && actions.includes(action)) ||
                                showInTransitTable
                                    ? formikInvoice.values
                                    : formik.values
                            }
                            tableBody={tableBody}
                            tableValues={tableValues}
                            tableActions={tableActions}
                            allData={{
                                totalRecords: all_invoices.totalRecords,
                            }}
                            isLoading={isLoading}
                            loadingTemplate={'table'}
                            searchData={searchData}
                            enableTableView={true}
                            selectedUpdate={selectedUpdate}
                            changeTableFunction={
                                (!searchVisible && actions.includes(action)) ||
                                showInTransitTable
                                    ? getAllInvoices
                                    : getInvoiceDetails
                            }
                            selectValues={alldata_all_dropdown}
                        />
                    </>
                )}
            </div>
            <InvoiceView
                data={manage}
                function={toggleFullScreenPopup}
                updateFunction={updateFunction}
            />
            <CustomDialog
                title={'Change invoice status'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                {isPopupLoading ? (
                    <Loaders name="home" isLoading={isPopupLoading} />
                ) : (
                    <>
                        {action === 'intransit' ? (
                            <>
                                <h5>
                                    Your Retreival Location does not match with
                                    User Retrieval Location{' '}
                                </h5>
                                <h5>Are you sure want to continue ?</h5>
                            </>
                        ) : (
                            <h5>
                                Are you sure you want to change the status ?
                            </h5>
                        )}
                        {formikSelection.values.action === 'cancelled' &&
                            mapData(reasonForCancelInvoice)}
                        <div className="actionWrapper">
                            <Button
                                id="invoice_cancel"
                                onClick={() => changeChangeStatus()}
                            >
                                Cancel
                            </Button>
                            <form
                                onSubmit={formikSelection.handleSubmit}
                                autoComplete="nofill"
                            >
                                <PrimaryButton
                                    id="invoice_confirm"
                                    type="submit"
                                    label="Confirm"
                                    disabled={btnDisabled}
                                />
                            </form>
                        </div>
                    </>
                )}
            </CustomDialog>
            <CustomDialog
                title={
                    action === 'new'
                        ? 'Confirm InTransit'
                        : action === 'intransit'
                          ? 'Confirm Ready for Pickup'
                          : action === 'pickup'
                            ? 'Confirm Completed'
                            : ''
                }
                open={transitStatus}
                function={changeTransitStatus}
            >
                {isPopupLoading ? (
                    <Loaders name="home" isLoading={isPopupLoading} />
                ) : (
                    <>
                        {action === 'intransit' ? (
                            <>
                                <h5>
                                    You are missing some products & also your
                                    Retreival Location does not match with User
                                    Retrieval Location{' '}
                                </h5>
                                <h5>Are you sure want to continue ?</h5>
                            </>
                        ) : (
                            <h5>
                                You are missing some products, Are you sure you
                                want to continue this action ?
                            </h5>
                        )}
                        <div className="actionWrapper">
                            <Button
                                id="invoice_cancel"
                                onClick={() => changeTransitStatus()}
                            >
                                Cancel
                            </Button>
                            <PrimaryButton
                                id="transit_confirm"
                                type="button"
                                onClick={() => {
                                    transitConfirm()
                                }}
                                label="Confirm"
                                disabled={btnDisabled}
                            />
                        </div>
                    </>
                )}
            </CustomDialog>
        </Layout>
    )
}

export default Order
